export default __webpack_public_path__ + "static/media/face_2_20.1f37efc6.png";